import styles from './styles.module.css';
import { Button } from '../Form/Button';
import ErrorIcon from '@/assets/icons/error.svg';

interface CardErrorProps {
  title?: string;
  errorMessage?: string;
  buttonText?: string;
  onClick?: () => void;
  onClose?: () => {} | void | undefined;
}

const CardError = ({
  title = 'Error',
  errorMessage = 'Something went wrong',
  buttonText = 'PLEASE TRY AGAIN',
  onClick = () => {},
  onClose = undefined
}: CardErrorProps) => {
  return (
    <div className={styles.container}>
      <img src={ErrorIcon} alt="Error" className={styles.errorIcon} />
      <p className={styles.errorText}>
        {title}: {errorMessage}
      </p>
      <span className={styles.btnContainer}>
        <Button
          onClick={onClick}
          color="blue"
          label={buttonText}
          size="medium"
          solid={false}
        />
      </span>

      {onClose && (
        <span className={styles.btnContainer}>
          <Button
            onClick={onClose}
            color="blue"
            label="CLOSE"
            size="medium"
            solid={false}
          />
        </span>
      )}
    </div>
  );
};

export default CardError;
